import {
  Component,
  OnInit,
  PLATFORM_ID,
  Inject,
  AfterViewInit,
  Renderer2
} from '@angular/core'
import { isPlatformBrowser, DOCUMENT, isPlatformServer } from '@angular/common'
import { Title, Meta } from '@angular/platform-browser'
import { LinkService } from '../../_services/langhfre.service'
import { MatDialog } from '@angular/material/dialog'
import { AiContentFeedbackModalComponent } from 'src/app/Components/ai-content-feedback-modal/ai-content-feedback-modal.component'
import { DetectionLimitExhaustModalComponent } from '../detection-limit-exhaust-modal/detection-limit-exhaust-modal.component'
import { ToastrService } from 'ngx-toastr';
import { WebsiteService } from 'src/app/_services/website.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { NoopScrollStrategy } from '@angular/cdk/overlay'
import * as $ from 'jquery'
import { Router } from '@angular/router';
import { LoadScriptService } from 'src/app/_services/load-script.service';
//declare function ire(string,{}): any;
declare const fpPromise: any;
@Component({
  selector: 'app-ai-detector-tool',
  templateUrl: './ai-detector-tool.component.html',
  styleUrls: ['./ai-detector-tool.component.scss']
})
export class AiDetectorToolComponent implements OnInit {
  inputWordCount: number = 0
  inputText: string = ''
  showWordLimitErr: boolean = false
  wordLimitErrHeading: string = ''
  wordLimitErrMsg: string = ''
  usersCurrentAvailableSessionCount: number = -1
  isSubmitBtnDisabled: boolean = false
  isAIContent: boolean = false
  aiContentScore: number = 0
  humanContentScore: number = 0
  showLoadingState: boolean = false
  showErrorModal: boolean = false
  setUserId: string = null
  contentDetectorLimit: number = 500
  aboveLimitText: string = ''
  isLimitExhausted: boolean = false;
  contactForm: FormGroup;
  formSection: boolean = true;
  thankSection: boolean = false;
  country: string;
  apiResponse: any = undefined;

  constructor (
    private toastr: ToastrService,
    private networkCall: WebsiteService,
    private fb: FormBuilder,
    private _dialog: MatDialog,
    private _appService: WebsiteService,
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    private router: Router,
    public loadScript: LoadScriptService,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
  ) {
    
  }

  ngOnInit() {
    this.titleService.setTitle("AI生成コンテンツ検出ツール｜Trinka");
    this.metaTagService.updateTag({ name: 'description', content: "TrinkaのAI生成コンテンツ検出ツールは、ChatGPT（GPT-4）、Bard、Bing Chatなど主要な生成系AIで生成された文章を検出。1日10回、1回500単語まで無料でご利用いただけます。" });
    this.metaTagService.updateTag({ property: 'og:title', content: "AI生成コンテンツ検出ツール｜Trinka" });
    this.metaTagService.updateTag({ property: 'og:description', content: "TrinkaのAI生成コンテンツ検出ツールは、ChatGPT（GPT-4）、Bard、Bing Chatなど主要な生成系AIで生成された文章を検出。1日10回、1回500単語まで無料でご利用いただけます。" });
    this.metaTagService.updateTag({ name: 'keywords', content: 'ai content detector, ai content detection, ai content detectors, ai contect detector, chatgpt detector, ai text detector, free ai detector, ai content detector free, ai detector for essays, ai content detection tool, best ai content detector, ai written text detector, ai generated text detector, ai content detector tools' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/ai-content-detector' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/why-choose-Trinka%20-AI-Content-Detector.svg' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'AI生成コンテンツ検出ツール｜Trinka' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "TrinkaのAI生成コンテンツ検出ツールは、ChatGPT（GPT-4）、Bard、Bing Chatなど主要な生成系AIで生成された文章を検出。1日10回、1回500単語まで無料でご利用いただけます。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/why-choose-Trinka%20-AI-Content-Detector.svg' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/ai-content-detector' });
    this.metaTagService.updateTag({ name: 'language', content: 'ja-jp' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/jp/ai-content-detector' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/ai-content-detector' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/ai-content-detector' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/ai-content-detector' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/ai-content-detector' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/ai-content-detector' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/ai-content-detector' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/ai-content-detector' });
    if (isPlatformServer(this.platformId)) {
      let script = this._renderer2.createElement('script');
      script.type = `application/ld+json`;
      script.text = `
      {"@context":"https://schema.org","@type":"FAQPage","mainEntity":[{"@type":"Question","name":"AI生成コンテンツ検出ツール／機能とは何ですか？","acceptedAnswer":{"@type":"Answer","text":"TrinkaのAI生成コンテンツの検出機能は、AIが生成したテキストを検出するための専用ソフトウェアです。確認対象のテキストがChatGPTのような生成系AIによって書かれたものなのか、あるいは人によって書かれたものなのかを判断し、テキストの信憑性を明確にします。"}},{"@type":"Question","name":"AI生成コンテンツ検出の仕組みはどのようなものですか？","acceptedAnswer":{"@type":"Answer","text":"自然言語処理、機械学習、ディープラーニングの技術を利用してテキストを分析します。人が書いた文章とAIが生成した文章との違いを識別し、どちらによって書かれたのかという予測をスコア付きで行います。学習を続けるAIを搭載し、その機能は向上を続けています。"}},{"@type":"Question","name":"盗用・剽窃の検出とAI生成文の検出の違いは何ですか？","acceptedAnswer":{"@type":"Answer","text":"盗用・剽窃の検出は、文書に盗用・剽窃に該当する箇所がないかをチェックするものです。盗用・剽窃とは、他人の作品、アイデア、コンテンツを適切な帰属や許可を得ずに使用することのため、その検出の目的は、研究倫理への違反や知的財産権の侵害といった不正の防止です。一方、AIが生成した文章の検出では、人工知能が生成したテキストを特定します。後者においても目的は文章のオリジナリティの確認ですが、検出の方法（既存の文献やコンテンツとの照合／AIによる生成テキストの傾向からの予測）が異なります。"}},{"@type":"Question","name":"学校への提出物にChatGPTのようなAIアシスタントを使用した場合、学校側でそれを検出できますか？","acceptedAnswer":{"@type":"Answer","text":"教育者・学校側には、学生が課題にAIを使用したかどうかを検知する手段があります。不自然な表現や、一貫性を欠いた文章があれば一目瞭然ですし、全体の中で矛盾がある場合や内容に深みがない場合もAIの使用は露呈するでしょう。また、AI生成文検出ツールを活用し、AIが使われた課題を効率的に洗い出す教育機関もあります。学校の課題など各種の提出物の作成に際してAIを使う場合、その使用に関する所属先のルールに従うべきです。"}},{"@type":"Question","name":"AI生成コンテンツの検出ツールは正確ですか？","acceptedAnswer":{"@type":"Answer","text":"巷にあるAIコンテンツ検出ツールの精度はさまざまです。TrinkaのAI生成コンテンツ検出機能は、ChatGPT（GPT-4）、Bard、およびその他の主要な生成系AIが生成したコンテンツを高い精度で識別します。テクノロジーの進化に伴い、TrinkaのAI生成コンテンツ検出機能は今後も精度を高めていきます。"}},{"@type":"Question","name":"GoogleはAIコンテンツを検出しますか？","acceptedAnswer":{"@type":"Answer","text":"Googleなどの検索エンジンは、AIが生成したコンテンツのSEOへの影響に関する懸念に対処するため、アルゴリズムの改善に積極的に取り組んでいます。AIは膨大な量の低品質なテキストを生み出すという懸念がありますが、検索エンジンはそのようなコンテンツを含むサイトを効果的に選別しようとしています。"}},{"@type":"Question","name":"Trinkaは、人が作成したテキストにAIが生成したテキストが追加された混合テキストを検出できますか？","acceptedAnswer":{"@type":"Answer","text":"はい、可能です。Trinkaの検出レポートでは、人が作成したテキストとAIが作成したテキストのそれぞれの部分についてのコメントを提供します。レポートには数値付きの判定が含まれており、コンテンツの出所に関する透明性について細かな内訳が示されます。検出レポートは法人向けのAI生成コンテンツ検出機能でのみご利用いただけます。詳しくはお問い合わせください。"}},{"@type":"Question","name":"TrinkaのAI生成コンテンツ検出ツールは無料で使えますか？","acceptedAnswer":{"@type":"Answer","text":"ツールは一定の制限付きで無料でご利用いただけます。上限は1日10回まで、1回あたり500単語までですが、ボリュームのある文書の場合は、分割してチェックにかけていただくことができます。"}}]}
      `;
      this._renderer2.appendChild(this._document.head, script);

      let script1 = this._renderer2.createElement('script');
      script1.type = `application/ld+json`;
      script1.text = `
      {"name":"AI生成コンテンツ検出ツール","@type":"Product","brand":{"name":"トリンカ","@type":"Brand"},"gtin8":"","image":"https://www.trinka.ai/jp/assets/images/trinka_logo.svg","@context":"https://schema.org/","description":"TrinkaのAI生成コンテンツ検出ツールは、ChatGPT（GPT-4）、Bard、Bing Chatなど主要な生成系AIで生成された文章を検出。1日10回、1回500単語まで無料でご利用いただけます。","aggregateRating":{"@type":"AggregateRating","bestRating":"5","ratingCount":"25545","ratingValue":"4.5","worstRating":"1"}}
      `;
      this._renderer2.appendChild(this._document.head, script1);

      let script2 = this._renderer2.createElement('script');
      script2.type = `application/ld+json`;
      script2.text = `
      {"@context":"https://schema.org","@type":"WebPage","name":"AI生成コンテンツ検出ツール｜Trinka","url":"https://www.trinka.ai/jp/ai-content-detector","description":"TrinkaのAI生成コンテンツ検出ツールは、ChatGPT（GPT-4）、Bard、Bing Chatなど主要な生成系AIで生成された文章を検出。1日10回、1回500単語まで無料でご利用いただけます。","image":"https://www.trinka.ai/jp/assets/images/trinka_logo.svg"}
      `;
      this._renderer2.appendChild(this._document.head, script2);

      let script3 = this._renderer2.createElement('script');
      script3.type = `application/ld+json`;
      script3.text = `
      {"@context":"https://schema.org/","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"AI英文校正ツールTrinka |学術英語に強いAIが英文添削","item":"https://www.trinka.ai/jp/"},{"@type":"ListItem","position":2,"name":"AI生成コンテンツ検出ツール","item":"https://www.trinka.ai/jp/ai-content-detector "}]}
      `;
      this._renderer2.appendChild(this._document.head, script3);

      //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
    }
    
    this.generateAndSetUserId();
    if(this.setUserId) this.getUserSessionCount();
    this._attachKeydownEventListener(document.getElementById('inputEditor'))
    this.attachPasteEventListener(document.getElementById('inputEditor'))
    if (isPlatformBrowser(this.platformId)) {
      // $.getScript('../../../assets/js/particles.min.js', function(){});
      // document.getElementById('main_header').classList.add('homepageHeader');
      $.getScript('../../../assets/js/hubslider.js', function () {})
      $.getScript('../../../assets/js/owl.carousel.min.js', function () {})
      $.getScript('../../../assets/js/wisepop.js', function () {})
      $.getScript('../../../assets/js/home_client_slider.js', function () {})
    }

    
    //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
  }

  onInputEditorChange (txt: string) {
    this._updateCounts(txt)
    this.resetScoreAndInputText()
    if (this.inputWordCount <= 500 && this.isSubmitBtnDisabled) {
      this.isSubmitBtnDisabled = false
    }
  }

  private _wordCount (text) {
    return text.split(/(\s+)/).filter(x => x.trim().length > 0).length
  }

  _updateCounts (txt: string) {
    this.inputText = txt
    this.inputWordCount = this._wordCount(txt.trim())
  }

  openFeedbackModal (likeFlag: boolean): void {
    try {
      const dialogRef = this._dialog.open(AiContentFeedbackModalComponent, {
        width: '500px',
        height: 'auto',
        disableClose: true,
        backdropClass: 'custom-dialog-background',
        panelClass: "border-radius16",
        data: {
          isLiked: likeFlag,
          inputText: this.inputText,
          userID: this.setUserId,
          apiResponse: this.apiResponse
        },
        scrollStrategy: new NoopScrollStrategy()
      })

      dialogRef.afterClosed().subscribe(result => {
      })
    } catch (e) {
      console.log('Err is: ', e)
    }
  }

  clearEditors (): void {
    this.inputWordCount = 0
    document.getElementById('inputEditor').innerHTML = ''
    this.resetScoreAndInputText()
  }

  sendTextForAIDetection() {
    this.generateAndSetUserId();
    if (this.inputWordCount < 100) {
      this.showWordLimitErr = true
      this.wordLimitErrMsg = ''
      this.wordLimitErrHeading = '100単語以上入力してください'
    } else if (this.inputWordCount > 500) {
      //for 500 words limit count
      this.isSubmitBtnDisabled = true
      this.showWordLimitErr = true
      this.wordLimitErrHeading = 'Word limit reached'
      this.wordLimitErrMsg =
        '一度に入力できるのは500単語までです。分割して、もう一度「チェック」をクリックしてください。'
      // setTimeout(() => {
      //   this.showWordLimitErr = false
      // }, 3000)
    } else if (this.usersCurrentAvailableSessionCount === 0) {
      this.showWordLimitErr = false
      this._dialog.open(DetectionLimitExhaustModalComponent, {
        backdropClass: 'custom-dialog-background',
        width: '490px',
        height: 'auto',
        scrollStrategy: new NoopScrollStrategy(),
        panelClass: "border-radius16",
      })
    } else if (this.showErrorModal) {
      this.clearEditors()
    } else {
      this.showWordLimitErr = false
      this.showLoadingState = true
      //API logic and session count will be deducted here
      let requestBody = {
        text: this.inputText
      }
      this._appService
        .aiDetectionRequest(requestBody, this.setUserId)
        .subscribe({
          complete: () => {},
          next: (response: any) => {
            this.apiResponse = response?.body?.result[0];
            this.showLoadingState = false;
            this.isAIContent = response?.body?.result[0]?.fake
            this.humanContentScore = this.isAIContent
              ? 0
              : response?.body?.result[0].human_score
            this.aiContentScore = this.isAIContent
              ? response?.body?.result[0].ai_score
              : 0
            this.getUserSessionCount()
            document
              .querySelector('#inputEditor')
              .childNodes.forEach((ele: HTMLElement) => {
                setTimeout(() => {
                  if (this.isAIContent) {
                    ele.style.backgroundColor = '#DC262626'
                    ele.style.color = '#DC2626'
                    ele.style.display = 'inline'
                    ele.style.fontWeight = '600'
                    ele.style.lineHeight = '26px'
                  }
                }, 500)
              })
          },
          error: error => {
            console.log('Error is: ', error);
            this.showLoadingState = false
            if (error?.status === 400 || error?.error?.error === 'Rate limit exceeded for today. Try again tomorrow.') {
              this.showWordLimitErr = false;
              this._dialog.open(DetectionLimitExhaustModalComponent, {
                backdropClass: 'custom-dialog-background',
                width: '490px',
                height: 'auto',
                scrollStrategy: new NoopScrollStrategy(),
                panelClass: "border-radius16",
              });
              this.usersCurrentAvailableSessionCount = 0;
            }
            else {
              this.showErrorModal = true;
              this.wordLimitErrMsg = '';
            }
          }
        })
    }
  }

  hideLimitError () {
    this.showWordLimitErr = false
  }

  resetScoreAndInputText () {
    this.isAIContent = false
    this.showErrorModal = false
    this.showLoadingState = false
    this.showWordLimitErr = false
    this.aiContentScore = 0
    this.humanContentScore = 0
  }

  private _attachKeydownEventListener (element: HTMLElement) {
    element.onfocus = (e: any) => {
      if (!element.children.length) {
        let newParagraph = document.createElement('p')
        newParagraph.innerHTML = '<br />'
        element.appendChild(newParagraph)
        window.getSelection().collapse(newParagraph, 0)
        e.preventDefault()
      }

      //TODO: To be added only if we want to disable Trinka's extension on the AI Content Detector's text-editor
      // if(document.querySelector('trinka-extension') && (document.querySelector('trinka-extension') as HTMLElement).style.display !== 'none') (document.querySelector('trinka-extension') as HTMLElement).style.display = 'none';
    }
    element.onblur = (e: any) => {
      if (!element.textContent) {
        element.innerHTML = ''
      }
      e.preventDefault()
    }
  }

  async generateAndSetUserId() {
    const today = new Date();
    const dateKey = `${today.getDate()}${today.getMonth() + 1}${today.getFullYear()}`
    this.setUserId = localStorage.getItem(dateKey)
    if (!this.setUserId) {
      const fingerprintJSResponse = (await (await fpPromise).get());
      this.setUserId = fingerprintJSResponse.visitorId;
      localStorage.setItem(dateKey, this.setUserId);
      this.getUserSessionCount();
    }
  }


  attachPasteEventListener(element: HTMLElement) {
    element.addEventListener('paste', ($event: any) => {
      $event.preventDefault()
      let text = $event.clipboardData.getData('text/plain');
      text = text.replace(/\n{2,}/g, '\n');
      document.execCommand('insertText', false, text);
    });
  }

  getUserSessionCount() {
    if (this.setUserId) {
      this._appService.getAIDetectionSessionCount(this.setUserId).subscribe({
        next: (response: any) => {
          this.usersCurrentAvailableSessionCount = response?.count;
        },
        complete: () => { },
        error: (err: any) => {
          this.usersCurrentAvailableSessionCount = 0;
        }
      })
    } 
    else this.usersCurrentAvailableSessionCount = 10;
  }

  
}
